//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { userBalance } from "../../../api";
import { conversion } from "../../../tool";

export default {
  name: "walletHistory",
  data() {
    return {
      detailfilter: -1,
      datefilter: 0,
      walletData: {
        data: { list: [] },
        current: 1,
        size: 15,
      },
    };
  },
  methods: {
    selectFilter() {
      var date = new Date();
      switch (this.datefilter) {
        case 0:
          break;
        case 2:
          date = date.setDate(date.getDate() - 3);
          break;
        case 3:
          date = date.setDate(date.getDate() - 7);
          break;
        case 4:
          date = date.setDate(date.getDate() - 10);
          break;
        case 5:
          date = date.setDate(date.getDate() - 15);
          break;		  
      }

      if(this.datefilter > 0){
        date = new Date(date).toLocaleDateString();
      } else{
        date = null;
      }

      this.getuserBalance({
        page: this.walletData.current,
        size: this.walletData.size,
        moneyDetailtype: this.detailfilter,
        start: date,
      });
    },
    getuserBalance(obj) {
      userBalance(obj).then((res) => {
        if (res.data.code === 0) {
          this.walletData.data.list = res.data.data.data || [];
          this.walletData.data.total = res.data.data.totalItems || 0;
        }
      });
    },
    pageF(v) {
      var date = new Date();
      switch (this.datefilter) {
        case 0:
          break;
        case 2:
          date = date.setDate(date.getDate() - 3);
          break;
        case 3:
          date = date.setDate(date.getDate() - 7);
          break;
        case 4:
          date = date.setDate(date.getDate() - 10);
          break;
        case 5:
          date = date.setDate(date.getDate() - 15);
          break;		  
      }

      if(this.datefilter > 0){
        date = new Date(date).toLocaleDateString();
      } else{
        date = null;
      }

      this.getuserBalance({
        page: v,
        size: this.walletData.size,
        moneyDetailtype: this.detailfilter,
        start: date,
      });
    },
  },
  filters: {
    conversion,
    add(v) {
      return v > 0 ? `+${v}` : v;
    },
  },
  created() {
    this.getuserBalance({
      page: this.walletData.current,
      size: this.walletData.size,
      moneyDetailtype: this.detailfilter
    });
  },
};
